<p-floatLabel>
  <p-select #shiftSelector
            id="shiftSelector"
            name="shiftSelector"
            [options]="shifts"
            [(ngModel)]="selectedShift"
            [showClear]="true"
            [checkmark]="true"
            [filter]="true"
            styleClass="w-100"
            [disabled]="isDisabled"
            (onChange)="onSelected()"
            optionLabel="name">
    <ng-template let-option pTemplate="item">
      {{ option?.name }}
    </ng-template>
  </p-select>
  <label for="shiftSelector">
    <app-label-content [isRequired]="isRequired">
      {{ l('::Shift') }}
    </app-label-content>
  </label>
</p-floatLabel>
